import { validateGrade } from '@ublend-npm/gradetype-utils';

import sanitizeGrades from './sanitizeGrades';

const parseGradesWithGradeType = ({ gradeType, grades }) => {
  const { sanitizedGrades, unsetGrades } = sanitizeGrades({
    grades,
    gradeType,
  });

  sanitizedGrades.forEach(({ grade }) => {
    const { valid } = validateGrade({ grade, gradeType });

    if (!valid) {
      throw new Error('invalid grade provided');
    }
  });

  return [...sanitizedGrades, ...unsetGrades];
};

export default parseGradesWithGradeType;
